export default "__VITE_ASSET__Dcpai2zh__"